import { useMemo } from "react";
import { useRefinementList, type UseRefinementListProps } from "react-instantsearch";

export const useFacet = (props: UseRefinementListProps) => {
  const { items, refine } = useRefinementList(props);

  const facetValueToCountMap = useMemo(() => {
    return new Map(items.map(({ value, count }) => [value, count]));
  }, [items]);

  const refinedValues = items.filter(({ isRefined }) => isRefined).map(({ value }) => value);

  const resetFacet = () => {
    for (const value of refinedValues) {
      refine(value);
    }
  };

  /** Make exactly `values` refined — what a dismissed modal needs to put its checkpoint back. */
  const setRefined = (values: readonly string[]) => {
    for (const value of refinedValues) {
      if (!values.includes(value)) refine(value);
    }
    for (const value of values) {
      if (!refinedValues.includes(value)) refine(value);
    }
  };

  return { items, refine, facetValueToCountMap, refinedValues, resetFacet, setRefined };
};
